import { useEffect, useState } from 'react';
import { PRODUCT_INFO_CATEGORIES, ProductCategoryId } from '../SectionInformation.constant';

const getOffetTop = (element: HTMLElement, offset = 200) => {
  // Adjust this value to set the space from the top
  const bodyRect = document.body.getBoundingClientRect().top;
  const elementRect = element.getBoundingClientRect().top;
  const elementPosition = elementRect - bodyRect;
  const offsetPosition = elementPosition - offset;

  return offsetPosition;
};

export const useScrollActive = () => {
  const [activeId, setActiveId] = useState<ProductCategoryId>(PRODUCT_INFO_CATEGORIES[0].id);

  const onCategoryClick = (id: ProductCategoryId) => {
    const element = document.getElementById(id);

    if (element) {
      const offsetTop = getOffetTop(element, 130);

      window.scrollTo({
        top: offsetTop,
        behavior: 'smooth',
      });
    }
  };

  useEffect(() => {
    const handleScroll = () => {
      PRODUCT_INFO_CATEGORIES.forEach((section) => {
        const element = document.getElementById(section.id);
        if (element) {
          const offsetTop = getOffetTop(element, 150);

          if (window.scrollY >= offsetTop && window.scrollY < offsetTop + element.offsetHeight) {
            setActiveId(section.id);
          }
        }
      });
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return { activeId, onCategoryClick, setActiveId };
};

